(() => {
  const angular = window.angular;

  angular.module('app').config(Router);

  Router.$inject = ['$stateProvider'];

  function Router($stateProvider) {
    $stateProvider.state('member.var.show.customer.show.project.eventImagesReport', {
      url: '/event-images-report',
      template: `<new-front-container path="'event-images-report'"></new-front-container>`,
      authenticated: true,
      ncyBreadcrumb: {
        label: '{{"entities.tool.__tools.EventImageReport" | translate}}',
      },
    });
  }
})();
